<template>
  <div>
    Display Document Name Fields Here...
  </div>
</template>

<script>
export default {
  name: 'DocumentNameIndexing',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
